import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_UPDATE_ENCRYPTION_SETTING_BEGIN,
  APP_SETTING_UPDATE_ENCRYPTION_SETTING_SUCCESS,
  APP_SETTING_UPDATE_ENCRYPTION_SETTING_FAILURE,
  APP_SETTING_UPDATE_ENCRYPTION_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function updateEncryptionSetting(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_UPDATE_ENCRYPTION_SETTING_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/encryption`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_UPDATE_ENCRYPTION_SETTING_SUCCESS,
              data: res.data,
            });
            if (res.data.success === false || res.data.status === 'FAILED') {
              toast.error(`Failed: ${getUserFriendlyKMSError(res.data)}`, {});
            } else {
              toast.success('Updated Successfully !', {});
            }
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_UPDATE_ENCRYPTION_SETTING_FAILURE,
              data: { error: err },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_UPDATE_ENCRYPTION_SETTING_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateEncryptionSettingError() {
  return {
    type: APP_SETTING_UPDATE_ENCRYPTION_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_UPDATE_ENCRYPTION_SETTING_BEGIN:
      return {
        ...state,
        updateEncryptionSettingPending: true,
        updateEncryptionSettingError: null,
      };

    case APP_SETTING_UPDATE_ENCRYPTION_SETTING_SUCCESS:
      const { data } = action;
      const finalState = {
        ...state,
        updateEncryptionSettingPending: false,
        updateEncryptionSettingError: null,
      };
      if (data.status !== 'FAILED') {
        finalState.projectDetail = {
          ...state.projectDetail,
          encryptions: data.encryptions,
        };
      }
      return finalState;

    case APP_SETTING_UPDATE_ENCRYPTION_SETTING_FAILURE:
      return {
        ...state,
        updateEncryptionSettingPending: false,
        updateEncryptionSettingError: action.data.error,
      };

    case APP_SETTING_UPDATE_ENCRYPTION_SETTING_DISMISS_ERROR:
      return {
        ...state,
        updateEncryptionSettingError: null,
      };

    default:
      return state;
  }
}

export const getUserFriendlyKMSError = (error) => {
  if (!error) return 'Unknown error occurred';
  const message = error.message || String(error);

  if (
    message.startsWith(
      'The request signature we calculated does not match the signature you provided',
    )
  ) {
    return 'Invalid AWS credentials. Please check your Access Key, Secret Key, and region settings.';
  }

  return message.split('\n')[0];
};
